const Logo = ({ compact = false, dark = false }) => (
  <img
    src={dark ? "/logo_sub.png" : "/logo.png"}
    alt="Scuola Didattica Sicura — Corsi di informatica"
    className={`w-auto ${compact ? "h-7 sm:h-8" : "h-8 sm:h-10"}`}
  />
);

export default Logo;
